import { cva } from 'class-variance-authority';

export const cvaCardContainer = cva(
  [
    'payments-pro-styles-cvaCardContainer',
    '',
    'rounded-[1rem]',
    'shadow-[0px_4px_40px_0px_rgba(0,0,0,0.24)]',
    'relative',
    'w-full',
    'max-w-[31.25rem]',
    'overflow-hidden',
    'transition-colors',
  ],
  {
    variants: {
      showCancelForm: {
        true: 'bg-general_text_MII_dark',
        false: 'bg-general_MI_800_disabled',
      },
    },
  },
);

export const cvaInnerContainer = cva([
  'payments-pro-styles-cvaInnerContainer',
  'box-border',
  'flex',
  'flex-col',
  'gap-6',
  'items-center',
  'pb-4',
  'pt-8',
  'px-8',
  'relative',
  'w-full',
]);

export const cvaTitleContainer = cva([
  'ff-inter',
  'payments-pro-styles-cvaTitleContainer',
  'flex',
  'flex-col',
  'gap-1',
  'items-start',
  'relative',
  'shrink-0',
  'text-left',
  'w-full',
  'z-[6]',
]);

export const cvaTitle = cva([
  'payments-pro-styles-cvaTitle',
  'text-font_ds_title_title_title_32',
  'relative',
  'shrink-0',
  'text-general_text_MII_default',
]);

export const cvaSubtitle = cva([
  'payments-pro-styles-cvaSubtitle',
  'text-font_ds_title_body_body_14',
  'relative',
  'shrink-0',
  'text-general_text_MII_secondary_ii',
  'text-nowrap',
  'whitespace-pre',
]);

export const cvaImageContainer = cva([
  'payments-pro-styles-cvaImageContainer',
  'bg-general_background_MIII_500_dark',
  'relative',
  'pointer-events-none',
  'rounded-lg',
  'shrink-0',
  'w-full',
  'z-[5]',
  'overflow-hidden',
]);

export const cvaImageBackground = cva([
  'payments-pro-styles-cvaImageBackground',
  'absolute',
  'inset-0',
  'rounded-lg',
]);

export const cvaPurpleGradient = cva([
  'payments-pro-styles-cvaPurpleGradient',
  'absolute',
  'left-[50%]',
  'size-[14.625rem]',
  'top-1/2',
  'translate-x-[-50%]',
  'translate-y-[-50%]',
  'bg-[#8B048E] opacity-[0.3]',
  'blur-[100px]',
  'rounded-full',
]);

export const cvaConfettiImage = cva([
  'payments-pro-styles-cvaConfettiImage',
  'absolute',
  'left-[50%]',
  'w-[344px]',
  'h-[244px]',
  'top-1/2',
  'translate-x-[-50%]',
  'translate-y-[-50%]',
  'rotate-[9deg]',
]);

export const cvaWonderslideImage = cva([
  'payments-pro-styles-cvaWonderslideImage',
  'absolute',
  'left-[50%]',
  'w-[171.096px]',
  'h-[171.096px]',
  'top-1/2',
  'translate-x-[-50%]',
  'translate-y-[-50%]',
  'rotate-[12deg]',
]);

export const cvaContentSection = cva([
  'payments-pro-styles-cvaContentSection',
  'flex',
  'flex-col',
  'items-center',
  'relative',
  'shrink-0',
  'z-[4]',
  'w-full',
]);

export const cvaRenewalText = cva([
  'ff-inter',
  'payments-pro-styles-cvaRenewalText',
  'text-font_ds_title_body_body_18',
  'relative',
  'shrink-0',
  'text-general_text_MII_default',
  'text-center',
  'text-nowrap',
  'whitespace-pre',
]);

export const cvaCancelButton = cva(['ff-inter', 'payments-pro-styles-cvaCancelButton', 'w-full']);

export const cvaTextarea = cva([
  'ff-inter',
  'payments-pro-styles-cvaTextarea',
  'bg-general_background_MIII_400_dark',
  'box-border',
  'gap-2',
  'px-3',
  'py-1.5',
  'relative',
  'rounded-lg',
  'shrink-0',
  'w-full',
  'min-h-[5rem]',
  'border',
  'border-general_MI_600_hower',
  'text-general_text_MII_disabled',
  'resize-none',
  'focus:outline-none',
  'focus:border-general_MI_500_default',
  'transition-colors',
]);

export const cvaButtonsContainer = cva([
  'payments-pro-styles-cvaButtonsContainer',
  'flex',
  'flex-col',
  'gap-4',
  'items-center',
  'relative',
  'shrink-0',
  'w-full',
]);

export const cvaSendButton = cva(['ff-inter', 'payments-pro-styles-cvaSendButton', 'w-full']);

export const cvaLeaveButton = cva(['ff-inter', 'payments-pro-styles-cvaLeaveButton', 'w-full']);

export const cvaGradientBottom = cva([
  'payments-pro-styles-cvaGradientBottom',
  'absolute',
  'bottom-[-384px]',
  'left-[calc(50%+0.5px)]',
  'size-[430px]',
  'translate-x-[-50%]',
  'z-[2]',
  'pointer-events-none',
]);

export const cvaGradientTop = cva([
  'payments-pro-styles-cvaGradientTop',
  'absolute',
  'left-[calc(50%+0.5px)]',
  'size-[430px]',
  'top-[-215px]',
  'translate-x-[-50%]',
  'z-[1]',
  'pointer-events-none',
]);
